import { ROUTE_NAMES } from '../app/constants/routes';

export enum Locale {
    CS = 'cs',
    DE = 'de',
    EN = 'en',
    ES = 'es',
    FR = 'fr',
    IT = 'it',
    NL = 'nl',
    PL = 'pl',
    PT = 'pt',
    RO = 'ro',
    RU = 'ru',
}

const LOCALE_ISO_MAP = {
    [Locale.CS]: 'cs-CS',
    [Locale.DE]: 'de-DE',
    [Locale.EN]: 'en-GB',
    [Locale.ES]: 'es-ES',
    [Locale.FR]: 'fr-FR',
    [Locale.IT]: 'it-IT',
    [Locale.NL]: 'nl-NL',
    [Locale.PL]: 'pl-PL',
    [Locale.PT]: 'pt-PT',
    [Locale.RO]: 'ro-RO',
    [Locale.RU]: 'ru-RU',
};

export const locales = Object.values(Locale).map(code => ({ code, language: LOCALE_ISO_MAP[code] }));

export const defaultLocale = Locale.EN;

export const i18nCustomPages = {
    [ROUTE_NAMES.ACCOUNT_DIRECT_SALES_VEHICLE_STATS]: {
        cs: '/account/vehicle-stats/buy-now/[id]',
        de: '/account/vehicle-stats/buy-now/[id]',
        en: '/account/vehicle-stats/buy-now/[id]',
        es: '/account/vehicle-stats/buy-now/[id]',
        fr: '/account/vehicle-stats/buy-now/[id]',
        it: '/account/vehicle-stats/buy-now/[id]',
        nl: '/account/vehicle-stats/buy-now/[id]',
        pl: '/account/vehicle-stats/buy-now/[id]',
        pt: '/account/vehicle-stats/buy-now/[id]',
        ro: '/account/vehicle-stats/buy-now/[id]',
        ru: '/account/vehicle-stats/buy-now/[id]',
    },
    [ROUTE_NAMES.AUCTION_DETAIL]: {
        cs: '/aukce/dp/[slug]',
        de: '/auktionen/dp/[slug]',
        en: '/auctions/dp/[slug]',
        es: '/subastas/dp/[slug]',
        fr: '/ventes-aux-encheres/dp/[slug]',
        it: '/aste/dp/[slug]',
        nl: '/veilingen/dp/[slug]',
        pl: '/aukcje/dp/[slug]',
        pt: '/leiloes/dp/[slug]',
        ro: '/licitati/dp/[slug]',
        ru: '/auktsiony/dp/[slug]',
    },
    [ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION]: {
        cs: '/aukce/dp/[slug]/jednani',
        de: '/auktionen/dp/[slug]/verhandlung',
        en: '/auctions/dp/[slug]/negotiation',
        es: '/subastas/dp/[slug]/negociacion',
        fr: '/ventes-aux-encheres/dp/[slug]/negociation',
        it: '/aste/dp/[slug]/negoziazione',
        nl: '/veilingen/dp/[slug]/onderhandeling',
        pl: '/aukcje/dp/[slug]/negocjacja',
        pt: '/leiloes/dp/[slug]/negociacao',
        ro: '/licitati/dp/[slug]/negociere',
        ru: '/auktsiony/dp/[slug]/peregovory',
    },
    [ROUTE_NAMES.AUCTION_LISTING]: {
        cs: '/aukce/[localizedAssetType]/[...optionalParams]',
        de: '/auktionen/[localizedAssetType]/[...optionalParams]',
        en: '/auctions/[localizedAssetType]/[...optionalParams]',
        es: '/subastas/[localizedAssetType]/[...optionalParams]',
        fr: '/ventes-aux-encheres/[localizedAssetType]/[...optionalParams]',
        it: '/aste/[localizedAssetType]/[...optionalParams]',
        nl: '/veilingen/[localizedAssetType]/[...optionalParams]',
        pl: '/aukcje/[localizedAssetType]/[...optionalParams]',
        pt: '/leiloes/[localizedAssetType]/[...optionalParams]',
        ro: '/licitati/[localizedAssetType]/[...optionalParams]',
        ru: '/auktsiony/[localizedAssetType]/[...optionalParams]',
    },
    [ROUTE_NAMES.DIRECT_SALE_DETAIL]: {
        cs: '/okamzity-nakup/dp/[slug]',
        de: '/sofortkauf/dp/[slug]',
        en: '/buy-now/dp/[slug]',
        es: '/compra-ahora/dp/[slug]',
        fr: '/achat-immediat/dp/[slug]',
        it: '/compra-subito/dp/[slug]',
        nl: '/nu-kopen/dp/[slug]',
        pl: '/kup-teraz/dp/[slug]',
        pt: '/compra-imediata/dp/[slug]',
        ro: '/cumpara-acum/dp/[slug]',
        ru: '/kupit-seychas/dp/[slug]',
    },
    [ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION]: {
        cs: '/okamzity-nakup/dp/[slug]/jednani',
        de: '/sofortkauf/dp/[slug]/verhandlung',
        en: '/buy-now/dp/[slug]/negotiation',
        es: '/compra-ahora/dp/[slug]/negociacion',
        fr: '/achat-immediat/dp/[slug]/negociation',
        it: '/compra-subito/dp/[slug]/negoziazione',
        nl: '/nu-kopen/dp/[slug]/onderhandeling',
        pl: '/kup-teraz/dp/[slug]/negocjacja',
        pt: '/compra-imediata/dp/[slug]/negociacao',
        ro: '/cumpara-acum/dp/[slug]/negociere',
        ru: '/kupit-seychas/dp/[slug]/peregovory',
    },
    [ROUTE_NAMES.DIRECT_SALE_LISTING]: {
        cs: '/okamzity-nakup/[localizedAssetType]/[...optionalParams]',
        de: '/sofortkauf/[localizedAssetType]/[...optionalParams]',
        en: '/buy-now/[localizedAssetType]/[...optionalParams]',
        es: '/compra-ahora/[localizedAssetType]/[...optionalParams]',
        fr: '/achat-immediat/[localizedAssetType]/[...optionalParams]',
        it: '/compra-subito/[localizedAssetType]/[...optionalParams]',
        nl: '/nu-kopen/[localizedAssetType]/[...optionalParams]',
        pl: '/kup-teraz/[localizedAssetType]/[...optionalParams]',
        pt: '/compra-imediata/[localizedAssetType]/[...optionalParams]',
        ro: '/cumpara-acum/[localizedAssetType]/[...optionalParams]',
        ru: '/kupit-seychas/[localizedAssetType]/[...optionalParams]',
    },
    [ROUTE_NAMES.SMART_LINK_VEHICLE]: false,
    [ROUTE_NAMES.STORYBLOK_PREVIEW]: false,
} as const;
